import { SmartTable } from '../../../../components/smart-table/smart-table.model';

export class Controller {

	/** @ngInject */
	constructor(
		$state,
		CompanyUser,
		ConfirmDeleteModal,
		SharedAccountsService,
		Alert
	) {
		this.$state = $state;
		this.CompanyUser = CompanyUser;
		this.ConfirmDeleteModal = ConfirmDeleteModal;
		this.SharedAccountsService =  SharedAccountsService;
		this.Alert = Alert;
	}

	$onInit() {
		this.labels$.get().then((labels) => this.labels = labels);
		this.selectedLabels = this.sharedLabels.filter((item) => item.isShared);

		this.$sharedLabels =  JSON.parse(JSON.stringify(this.sharedLabels));
        this.newUserIdentifier = null;
        this.userIdentifier = null;
        this.st = new SmartTable();
        this.stLabels = new SmartTable();
	}

	identifyUser() {
		this.message = null;
		this.userIdentifier = this.newUserIdentifier;

		this.CompanyUser.identifyCompanyUser({
			companyId: this.companyId,
			uid: encodeURIComponent(this.userIdentifier)
		}).$promise
			.then((response) => {

				this.successResult = true;
				this.showVerification = false;
				this.companyUser = response;

				this.message = 'groups_users.user_found';
			})
			.catch((error) => {
				this.successResult = false;
				this.companyUser = null;

				this.showVerification = this.enableVerification && !this.successResult
					&& $rootScope.emailPattern.test(this.userIdentifier);

				if (error.status == 404) {
					this.message = 'groups_users.user_not_found';
				} else {
					this.message = response.data.message;
				}
			})

	}

	getSharingTypeDisplayName(sharingType) {
        if (sharingType == 'INDIVIDUAL_AND_TEAM') {
            return 'INDIVIDUAL & TEAM';
        } else {
            return sharingType;
        }
    }

	share(saaspassId) {
		var param = {
			companyId: this.companyId,
			id: this.sharedAccountId,
			saaspassId: saaspassId
		}
		if(this.isNote){
			this.SharedAccountsService.shareNoteWithSaaspassUser(param, {}).$promise.then((response) => {
                    this.successMessageAndReloadNoteUsers('shared_accounts.messages.share_account');
                }).catch((error) => {});
		} else {
			this.SharedAccountsService.shareCompanyServiceAccounts(param, {}).$promise.then((response) => {
				this.successMessageAndReloadUsers('shared_accounts.messages.share_account');
			}).catch((error) => {});
		}
	}

	unshare(saaspassId) {
		//this.type = 'SINGLE';
		this.saaspassId = saaspassId;
		this.ConfirmDeleteModal('groups_users.confirm_shared_email_account_delete')
			.then(() => {
				var param = {
					companyId: this.companyId,
					id: this.sharedAccountId,
					saaspassId: this.saaspassId
				}
				if (this.isNote) {
					this.SharedAccountsService.unshareUserNote(param, {}).$promise.then((response) => {
                    	this.successMessageAndReloadNoteUsers('shared_accounts.messages.unshare_account');
               		}).catch((error) => { });
				} else {
					this.SharedAccountsService.unshareCompanyServiceAccounts(param, {}).$promise.then((response) => {
						this.successMessageAndReloadUsers('shared_accounts.messages.unshare_account');
					}).catch((error) => { });
				}
			});
	}

	cancelSearch() {
		this.userIdentifier = null;
		this.successResult = null;
		this.showVerification = false;
		this.companyUser = null;
		this.message = null;
		this.newUserIdentifier = null;
	}
	
	clickLabel(label) {
		if (label.name === "ALL_USERS") {
			this.sharedLabels.map((item) => {
				if (item.name !== "ALL_USERS") {
					item.isShared = false;
				}
			});
		}
		this.selectedLabels = this.sharedLabels.filter((item) => item.isShared);
	}

	isCheckboxDisabled(label) {
		var isIt = (label.name !== "ALL_USERS") && (this.selectedLabels.length==1) && (this.selectedLabels[0].name==="ALL_USERS");
		return isIt;
	}

	sharedLabelsNotModified() {
		return angular.equals(this.$sharedLabels, this.sharedLabels);
	}
	
	shareWithLabels(){
		var param = {
			companyId: this.companyId,
			id: this.sharedAccountId
		}
		if (this.isNote) {
			 this.SharedAccountsService.updateCompanyNoteLabels(param, this.sharedLabels).$promise.then((response) => {
                    this.successMessageAndReloadNoteUsers('shared_accounts.messages.share_account');
                }).catch((error) => { });
		} else {
			 this.SharedAccountsService.updateServiceAccountLabels(param, this.sharedLabels).$promise.then((response) => {
				this.successMessageAndReloadUsers('shared_accounts.messages.share_account');
			}).catch((error) => { });
		}
	}
	
	successMessageAndReloadUsers(key) {
		this.$state.go('.', {}, {reload: '.'});
		this.Alert('success', key);
		
	}
	successMessageAndReloadNoteUsers(key) {
		this.$state.go('.', {}, {reload: '.'});
		this.Alert('success', key);
		
	}
	
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/share/share.controller.js